
import { defineComponent, computed, onMounted, onUnmounted, ref, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import {
  MypageFoodsRanking
} from "@/types/mypage";
import { convertRemToPx } from "@/utils/common-utils";

export default defineComponent({
  name: "MypageFoodsRankingContentFoodsRankingCard",
  props: {
    /** タイトル */
    cardTitle: {
      type: String,
      required: true
    },
    /** タイプ true：使い切り食材、false：捨てた食材 */
    isValidRankImage: {
      type: Boolean,
      required: true
    },
    /** 個人食品ランキング */
    personalFoodsRanking: {
      type: MypageFoodsRanking,
      required: true
    },
    /** 全国食品ランキング */
    nationwideFoodsRanking: {
      type: MypageFoodsRanking,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const userTitleText = "あなた";
    const nationwideTitleText = "全国";

    let isClickedQuestion = false;
    const clickQuestion = () => {
      NativeClient.sendDebugLog("MypageFoodsRankingContentFoodsRankingCard clickQuetion");
      isClickedQuestion = true;
      context.emit("click-question")
    };

    const clickArea = () => {
      if (!isClickedQuestion) {
        NativeClient.sendDebugLog("MypageFoodsRankingContentFoodsRankingCard clickArea");
        context.emit("click-area")
      }
      isClickedQuestion = false;
    };

    // ランクの表示
    const rankArray = [
      { id: 1, image: require("@/assets/images/icon_crown_first_rank.png"), rankText: "1位" },
      { id: 2, image: require("@/assets/images/icon_crown_second_rank.png"), rankText: "2位" },
      { id: 3, image: require("@/assets/images/icon_crown_third_rank.png"), rankText: "3位" }
    ];

    // 表示する食品情報
    class MypageFoodsRankingContentFoodsRankingCardFoodItem {
      foodId: number;
      image: string;
      consumeCount: number;
      isValidItem: boolean;
      constructor() {
        this.foodId = 0;
        this.image = "";
        this.consumeCount = 0;
        this.isValidItem = false;
      }
    };

    // 個人と全国共通
    const generateFoodList = (foodData: MypageFoodsRanking | null) => {
      const result: Array<MypageFoodsRankingContentFoodsRankingCardFoodItem> = [
        { foodId: -1, image: "", consumeCount: 0, isValidItem: false },
        { foodId: -2, image: "", consumeCount: 0, isValidItem: false },
        { foodId: -3, image: "", consumeCount: 0, isValidItem: false }
      ];
      if (foodData != null) {
        for (let index = 0; index < foodData.foods.length && index < 3; index ++) {
          const element = new MypageFoodsRankingContentFoodsRankingCardFoodItem();
          element.foodId       = foodData.foods[index].foodId;
          element.image        = foodData.foods[index].image;
          element.consumeCount = foodData.foods[index].consumeCount;
          element.isValidItem = true;
          result[index] = element;
        }
      }
      return result;
    }
    // 個人の食品
    const personalFoodList = computed(() => {
      return generateFoodList(props.personalFoodsRanking);
    });

    // 全国の食品
    const nationwideFoodList = computed(() => {
      return generateFoodList(props.nationwideFoodsRanking);
    });

    const onImageError = (event: Event) => {
      NativeClient.sendDebugLog("MypageFoodsRankingContentFoodsRankingCard onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("MypageFoodsRankingContentFoodsRankingCard onImageError target not exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/noimage1.png"); 
      }
    };

    // サイズ計算
    const calculateItemSize = () => {
      const screenWidth = window.innerWidth;
      const contentsWidth = screenWidth - convertRemToPx(6.4 + 5.4);
      const itemMaxWidth = convertRemToPx(8);
      const marginBetweenItems = convertRemToPx(0.6);
      const standardContentWidth = itemMaxWidth * 3 + marginBetweenItems * 2;
      if (contentsWidth >= standardContentWidth) {
        return { itemWidth: itemMaxWidth, itemHeight: itemMaxWidth }
      }
      // 項目の幅を調整する。項目間のマージンは、0.6remにして、残りを項目が占有する
      const itemWidth = Math.floor((contentsWidth - marginBetweenItems * 2) / 3);
      return { itemWidth: itemWidth, itemHeight: itemWidth }
    };
    const styleFoodItemSize = computed(() => {
      const itemSize = calculateItemSize();
      return { width: `${itemSize.itemWidth}px`, height: `${itemSize.itemHeight}px`}
    });

    return {
      userTitleText,
      nationwideTitleText,
      rankArray,
      personalFoodList,
      nationwideFoodList,
      styleFoodItemSize,
      onImageError,
      clickQuestion,
      clickArea
    };
  }
});
